import { createApp } from 'vue'
import { createMetaManager, defaultConfig } from 'vue-meta'

import router from './router'
import App from './App.vue'

const app = createApp(App)
const meta = createMetaManager(false, {
  ...defaultConfig,
  meta: { tag: 'meta', nameless: true }
})

app.use(router)
app.use(meta)
app.mount('#app')
